module.exports = __webpack_public_path__ + "static/media/VB_example.b3e11b21.zip";